export enum EnumTransactionStatus {
  Rejected = -2,
  Failed = -1,
  Pending = 1,
  Approved = 2,
  Completed = 3,
}
